// @flow
export type Translation = { [key: string]: string };

export type TranslationsApiItem = {
  key: string,
  value: string
};

export default function modelTranslation(
  item: TranslationsApiItem
): Translation {
  return {
    [item.key]: item.value
  };
}



// WEBPACK FOOTER //
// ./src/redux/models/translation.js